import apiClient from '../../api/apiClient';

export const editProfileApi = async (profileData) => {
  const response = await apiClient.patch('/partners/oem-partners/profile', profileData);
  return response.data;
};

export const changePasswordApi = async (passwordData) => {
  const response = await apiClient.patch('/partners/oem-partners/change-password', passwordData);
  return response.data;
};

export const verifyEmailApi = async (emailData) => {
  const response = await apiClient.post('/partners/oem-partners/verify-mail', emailData);
  return response.data;
};

export const verifyTokenApi = async (token, email) => {
  const response = await apiClient.post(`/partners/oem-partners/verify-token?token=${token}&email=${email}`);
  return response.data;
};